import AcxExpansion from "components/UI/AcxExpansion";
import { INavigationGroup } from "Layouts/SideNavigation/NavigationStore";
import React from "react";

import theme from "../../Theme/AppTheme";
import SideNavigationLink from "./SideNavigationLink";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";

type Props = {
    items: INavigationGroup[];
    currentNavItem: string;
    organizationId: string;
    isLoading?: boolean;
    signalsVariant?: boolean;
};

const SideNavigation: React.FC<Props> = observer((props) => {
    const { items, currentNavItem, organizationId, isLoading } = props;

    return (
        <>
            {isLoading ? (
                <AcxLoadingIndicator
                    size={45}
                    alternate="PuffLoader"
                    style={{ paddingTop: theme.spacing(4) }}
                />
            ) : (
                items.map((item, i) => (
                    <AcxExpansion
                        expanded={item.expanded ?? true}
                        headerSx={{
                            fontSize: props.signalsVariant ? "14px" : "16px",
                            fontFamily: "Inter",
                            fontWeight: "bold",
                            color: theme.palette.black.main,
                            marginBottom: theme.spacing(1),
                            marginTop: theme.spacing(1),
                            "&:hover": {
                                textDecoration: "underline",
                            },
                        }}
                        header={
                            item.linkPath === "" || item.linkPath ? (
                                <Link
                                    to={item.linkPath ?? ""}
                                    style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                    }}
                                >
                                    {item.header}
                                </Link>
                            ) : (
                                item.header
                            )
                        }
                        key={`side-nav-${i}`}
                        body={item.items.map((subItem, index) => (
                            <SideNavigationLink
                                key={`side-nav-item-${subItem.title?.toString()}-${index}`}
                                val={subItem}
                                currentNavItem={currentNavItem}
                                replaceLinks={{ organizationId }}
                            />
                        ))}
                        bodyStyle={{
                            paddingRight: theme.spacing(0.5),
                            paddingLeft: theme.spacing(1.75),
                        }}
                        rootStyle={{
                            paddingRight: theme.spacing(0.75),
                            paddingLeft: theme.spacing(0.75),
                            width: "100%",
                        }}
                        chevronCloseSx={
                            props.signalsVariant
                                ? {
                                      marginLeft: "0px",
                                      marginRight: theme.spacing(1.5),
                                  }
                                : undefined
                        }
                        chevronExpandedSx={
                            props.signalsVariant
                                ? {
                                      marginLeft: "0px",
                                      marginRight: theme.spacing(1.5),
                                  }
                                : undefined
                        }
                        unmountOnExit
                    />
                ))
            )}
        </>
    );
});

export default SideNavigation;
